import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

export const NumericalProgress: ReactTFC<{
  duration: number | undefined;
  currentTime: number | undefined;
}> = props => {
  function calculateLabel() {
    if (
      typeof props.duration !== "undefined" && props.duration > 0 &&
      Number.isFinite(props.duration) &&
      typeof props.currentTime == "number" &&
      Number.isFinite(props.currentTime)
    ) {
      return `${formatMMSS(Math.floor(props.currentTime))} / ${formatMMSS(Math.floor(props.duration))}`;
    } else {
      return "00:00 / 00:00";
    }
  }

  const label = calculateLabel();

  return <React.Fragment> {label}</React.Fragment>;
};

function formatMMSS(duration: number) {
  const minutes = Math.floor(duration / 60);
  const seconds = duration - minutes * 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}
